module.exports = __webpack_public_path__ + "img/new-checkbox.28d1c7e2.svg";